import React, { useRef, useState } from 'react';
import { TickCircleIcon } from 'evergreen-ui';

export default function CommunicationCompletion({ communication, complete }) {
  const [confirm, setConfirm] = useState(false), [busy, setBusy] = useState(false), [saved, setSaved] = useState(false), [error, setError] = useState('');
  const lock = useRef(false);
  const submit = async () => {
    if (lock.current || saved) return;
    lock.current = true; setBusy(true); setError('');
    try {
      const result = await complete(communication);
      if (result?.ok === true) setSaved(true);
      else setError(result?.code === 'resource_revision_conflict'
        ? 'This follow-up changed. Refresh notifications before trying again.'
        : 'Completion could not be confirmed. Use Review change to recover the original request.');
    } catch { setError('Completion could not be confirmed. Refresh notifications or review the pending change.'); }
    finally { lock.current = false; setBusy(false); }
  };
  return <div style={{ padding: '0 16px 16px', display: 'grid', gap: 8, minWidth: 0 }} aria-busy={busy}>
    {saved ? <p role="status">Follow-up completed</p> : confirm ? <>
      <strong>Complete this follow-up?</strong>
      <p style={{ margin: 0 }}>The message stays in history. No message will be sent and no payment will be changed.</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        <button type="button" className="is2-button is2-button--primary" disabled={busy} onClick={() => { void submit(); }}><TickCircleIcon size={14} />{busy ? 'Completing...' : 'Confirm completion'}</button>
        <button type="button" className="is2-button is2-button--quiet" disabled={busy} onClick={() => setConfirm(false)}>Keep open</button>
      </div>
    </> : <button type="button" className="is2-button is2-button--quiet" style={{ justifySelf: 'start' }} onClick={() => setConfirm(true)}><TickCircleIcon size={14} />Complete follow-up</button>}
    {error ? <p role="alert">{error}</p> : null}
  </div>;
}
